<template>
    <button :type="type" class="btn px-100" :class="classList" @click="$emit('click')">
        <slot></slot>
    </button>
</template>

<script>
export default{
    props:{
        type:{
            type: String,
            default: 'button',
            validation: (value)=>{
                return ['button', 'submit', 'reset'].includes(value)
            }
        },
        variation:{
            type:String,
            default: 'muted',
            validation: (value)=>{
                return ['muted', 'primary'].includes(value)
            }
        },
        outline:{
            type:[Boolean, String],
            default: false,
            validation:(value)=>{
                return [true, false, 'true', 'false'].includes(value)
            }
        },
        rounded:{
            type:[Boolean, String],
            default: false,
            validation:(value)=>{
                return [true, false, 'true', 'false'].includes(value)
            }
        },
        disabled:{
            type:[Boolean, String],
            default: false,
            validation:(value)=>{
                return [true, false, 'true', 'false'].includes(value)
            }
        }
    },
    computed:{
        isOutline(){
            return [true, 'true'].includes(this.outline)
        },
        isRounded(){
            return [true, 'true'].includes(this.rounded)
        },
        isDisabled(){
            return [true, 'true'].includes(this.disabled)
        },
        classList(){
            return `${this.variation} ${this.isOutline? 'outline': 'solid'} ${this.isRounded ? 'rounded': ''} ${this.isDisabled ? 'disabled': ''}`
        }
    },
}
</script>